import { createI18n } from "vue-i18n";
import en from "./en";
import de from "./de";
import zh from "./zh";

const storage = typeof window !== "undefined" ? window.localStorage : undefined;
const validLocales = ["en", "de", "zh"] as const;
export type LocaleCode = (typeof validLocales)[number];

const savedLocale = storage?.getItem("locale") ?? null;
const initialLocale: LocaleCode = ((): LocaleCode => {
  if (savedLocale && validLocales.includes(savedLocale as LocaleCode)) {
    return savedLocale as LocaleCode;
  }
  return "en";
})();

// If saved locale is invalid (e.g., legacy value), reset to English
if (savedLocale && !validLocales.includes(savedLocale as LocaleCode)) {
  storage?.setItem("locale", "en");
}

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: initialLocale, // Default language: English
  fallbackLocale: "en", // Fallback language: English
  messages: {
    en,
    de,
    zh,
  },
});

export default i18n;

// Export language switching function
export function setLocale(locale: LocaleCode) {
  i18n.global.locale.value = locale;
  storage?.setItem("locale", locale);

  if (typeof document !== "undefined") {
    document.documentElement.lang = locale;
  }
}

// Export current locale
export function getCurrentLocale() {
  return i18n.global.locale.value as LocaleCode;
}

// Export available locales list
export const availableLocales: { code: LocaleCode; name: string; flag: string }[] = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "zh", name: "中文", flag: "🇨🇳" },
];

